import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export function Body(_ref) {
  var children = _ref.children,
      _ref$innerRef = _ref.innerRef,
      innerRef = _ref$innerRef === void 0 ? null : _ref$innerRef,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown;
  return React.createElement("div", {
    onKeyDown: onKeyDown,
    tabIndex: -1,
    ref: innerRef,
    className: classNames('shadow-hovering scroll-y radius-large overflow-hidden zindex-small text-align-left', className, 'data-hj-whitelist' //Hotjar whitelist
    ),
    style: _objectSpread({
      width: 300,
      maxHeight: 'calc(100vh - 10px)',
      outline: 'none'
    }, style)
  }, children);
}
export function Title(_ref2) {
  var children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className;
  return React.createElement("div", {
    className: classNames('font-weight-medium shade-05', 'padding-vertical-normal padding-horizontal-medium', 'background-white', 'border-bottom-medium border-shade-50', className)
  }, children);
}
export var Item =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Item, _React$Component);

  function Item() {
    _classCallCheck(this, Item);

    return _possibleConstructorReturn(this, _getPrototypeOf(Item).apply(this, arguments));
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(React.Fragment, null, React.createElement("div", {
        "data-qa": this.props['data-qa'],
        className: classNames('transition', 'padding-medium pointer font-weight-medium ', 'background-white background-shade-50-on-hover background-shade-50-on-focus', 'shade-10 shade-05-on-hover shade-05-on-focus', {
          'border-bottom-medium border-shade-50': this.props.divider
        }, this.props.className),
        style: this.props.style,
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();

          _this.props.onRowClick();

          _this.props.action();
        }
      }, React.createElement("div", {
        className: "flexbox flexbox-align-center"
      }, this.props.icon && React.createElement("div", {
        className: "flexbox-no-grow padding-right-normal shade-30"
      }, this.props.icon), this.props.image && React.createElement("div", {
        className: "flexbox flexbox-align-center flexbox-no-grow padding-right-normal"
      }, React.createElement("img", {
        src: this.props.image,
        alt: "item",
        style: {
          width: 16,
          maxHeight: 16
        }
      })), React.createElement("div", {
        className: "flexbox-grow"
      }, this.props.subtitle ? React.createElement("div", {
        style: {
          lineHeight: '14px'
        }
      }, React.createElement("div", {
        className: "font-weight-medium"
      }, this.props.children), React.createElement("div", {
        className: "font-weight-regular font-size-smaller"
      }, this.props.subtitle)) : React.createElement("div", null, this.props.children)))));
    }
  }]);

  return Item;
}(React.Component);

_defineProperty(Item, "propTypes", {
  icon: PropTypes.node,
  image: PropTypes.node,
  children: PropTypes.node.isRequired,
  action: PropTypes.func.isRequired,
  divider: PropTypes.bool,
  subtitle: PropTypes.node,
  onRowClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  'data-qa': PropTypes.string,
  style: PropTypes.object
});

_defineProperty(Item, "defaultProps", {
  onRowClick: function onRowClick() {},
  style: {},
  className: ''
});